export const isNewQuizAvailable = (lastPlayedDay) => {
  let today = new Date()
  let UTCTimeString = today.toUTCString().slice(0,16)
  //console.log("UTCTimeString : ", UTCTimeString)
  return (!(lastPlayedDay === UTCTimeString))

}

export const getNextQuizTime = () =>{

}